module.exports = __webpack_public_path__ + "img/car-wash.24956f91.svg";